import {
  FETCH_ORDER_DETAIL_PENDING,
  FETCH_ORDER_DETAIL_REJECTED,
  FETCH_ORDER_DETAIL_FULFILLED,
  CLEAR_FETCH_ORDER_DETAIL,
} from 'constants/changeItemOrderDetail';

const initialState = {
  pending: true,
  orderDetails: {},
  error: {},
  success: false,
};

export const changeItemOrderDetail = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ORDER_DETAIL_FULFILLED:
      return {
        ...state,
        orderDetails: action.response,
        pending: false,
        success: true,
      };

    case FETCH_ORDER_DETAIL_REJECTED:
      return { ...state, pending: false, error: action.error };

    case FETCH_ORDER_DETAIL_PENDING:
      return {
        ...state,
        error: {},
      };

    case CLEAR_FETCH_ORDER_DETAIL:
      return initialState;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/changeItemOrderDetail.js